enum TypeDocumentId {
  SENTENCIAS = "657748cb08c57c5d952cfb5a",
  ACUERDO = "65846bec7f2c7be3ada5ba6c",
  JURISPRUDENCIAS = "6568be5b8cb985a4da4df59e",
  LIBRE = "655d30518072fe5eefaeb3cf",
}

export { TypeDocumentId };
